import { render, staticRenderFns } from "./approvalRule.vue?vue&type=template&id=47bc3d2b&scoped=true&"
import script from "./approvalRule.vue?vue&type=script&lang=js&"
export * from "./approvalRule.vue?vue&type=script&lang=js&"
import style0 from "./approvalRule.vue?vue&type=style&index=0&id=47bc3d2b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bc3d2b",
  null
  
)

export default component.exports